import p1 from '@/assets/images/landing/programme/programme-1.jpg'
import p2 from '@/assets/images/landing/programme/programme-2.jpg'
import p3 from '@/assets/images/landing/programme/programme-3.jpg'
import avatar1 from '@/assets/images/landing/avatars/avatar-1.png'
import avatar2 from '@/assets/images/landing/avatars/avatar-2.png'
import avatar3 from '@/assets/images/landing/avatars/avatar-3.png'
import avatar4 from '@/assets/images/landing/avatars/avatar-4.png'

export const programmeImages = [p1, p2, p3]
export const programmeAvatars = [avatar1, avatar2, avatar3, avatar4, avatar3]
